exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".multiselect__option--selected {\n  color: var(--gray-dark);\n  font-weight: 500;\n}\n.option__title {\n  font-size: 0.9375rem;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n  margin-bottom: 0.1875rem;\n}\n.option__small {\n  font-size: 0.8375rem;\n}\n.multiselect.is-invalid .multiselect__tags {\n  border-color: var(--danger);\n}", ""]);

// exports
